import Help16 from '@carbon/icons-react/es/help/16';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { Checkbox } from 'components/atoms/checkbox';
import { DatePicker } from 'components/atoms/date-picker';
import { Input, InputNumber, TextArea } from 'components/atoms/input';
import { Label01, Text02, Text03 } from 'components/styles';

export const Row = styled.div<{ $private?: 'true' | 'false' }>`
  display: flex;
  flex-shrink: 0;
  ${ifProp(
    { $private: 'true' },
    css`
      background-color: var(--private-01);
    `,
  )};
`;

export const Left = styled.div`
  text-align: left;
  flex: 0 0 auto;
  padding-right: var(--spacing-03);
  width: 304px;
`;
export const Right = styled.div`
  display: flex;
  flex: 1 1 auto;
  min-width: 1px;
  height: var(--height-lg);
`;

export const Content = styled(Right)`
  align-items: center;
`;

export const LabelContainer = styled.div`
  height: 40px;
  align-items: center;
  display: flex;
  justify-content: left;
`;

export const FieldLabel = styled.div`
  ${Text02};
  display: contents;

  .ant-typography {
    color: inherit;
    margin-bottom: 0;
  }
`;

export const FieldGroupLabel = styled(FieldLabel)`
  ${Label01};
  ${Text03};
`;

export const FieldGroupRow = styled(Row)`
  border-bottom: 1px solid var(--border-color);
`;

export const Help = styled(Help16)`
  margin-left: var(--spacing-02);
  min-width: 16px;
`;

export const GhostFields = styled.div`
  padding: var(--spacing-04) 0;
  .ant-picker {
    width: 100%;
  }
  .ozone-select-container {
    width: 100%;

    &.ozone-select--is-disabled {
      pointer-events: auto;
    }
  }
  .ozone-select-container > .ozone-select__control,
  ${Input}, ${InputNumber}, ${DatePicker}, ${TextArea} {
    border: none;
    background: transparent;
  }
  ${TextArea}:focus {
    background-color: var(--gray-10);
    border-bottom: 1px solid var(--gray-50);
  }
  .ozone-select__placeholder {
    margin-left: var(--spacing-03);
  }
  ${Checkbox} {
    display: flex;
    align-items: center;
    height: 40px;
    padding-left: var(--spacing-05);
  }

  ${Left} {
    padding-left: var(--spacing-05);
  }
`;

export const PrivateIcon = styled.span`
  font-size: var(--font-size-sm);
  padding-right: var(--spacing-03);
  position: relative;
  top: var(--spacing-02);
  color: var(--gray-50);
`;
